import { gql } from "../__generated__";

gql(`
    fragment InvitationFields on Invitation {
        id
        phoneNumber
        email
        createdAt
        token
        senderName
        clientName
        clientLogoUrl
        clientFormattedAddress
        text
        mode
        firstName
        lastName
        target
    }
`);

export const ONBOARDING_INVITATIONS = gql(`
    query OnboardingInvitations {
        onboardingInvitationsReceived {
            ...InvitationFields
        }
    }
`);

export const GET_INVITATION = gql(`
    query GetInvitation($invitationId: ID!) {
        getInvitation(invitationId: $invitationId) {
            ...InvitationFields
        }
    }
`);

// An email invitation, found by the code its email carries (`XXXX-XXXX`; case, spaces and dashes are
// ignored). Answers without a Lift user and binds nothing: what someone signing up is shown before
// they give the code with the profile they create (`invitationCode` on the profile input).
export const INVITATION_BY_CODE = gql(`
    query InvitationByCode($code: String!) {
        invitationByCode(code: $code) {
            __typename
            ... on InvitationCodeSuccess {
                invitation {
                    ...InvitationFields
                }
            }
            ... on InvitationCodeError {
                message
                messageKey
            }
        }
    }
`);

// Makes the email invitation with that code the signed-in user's: it is then listed and answered
// (getInvitation, acceptInvitation, rejectInvitation) like one sent to their phone number.
export const CLAIM_INVITATION = gql(`
    mutation ClaimInvitation($code: String!) {
        claimInvitation(code: $code) {
            __typename
            ... on InvitationCodeSuccess {
                invitation {
                    ...InvitationFields
                }
            }
            ... on InvitationCodeError {
                message
                messageKey
            }
        }
    }
`);

export const ACCEPT_INVITATION = gql(`
    mutation AcceptInvitation($token: String!) {
        acceptInvitation(token: $token)
    }
`);

export const REJECT_INVITATION = gql(`
    mutation RejectInvitation($token: String!, $code: String) {
        rejectInvitation(token: $token, code: $code)
    }
`);

export const CANCEL_INVITATION = gql(`
    mutation CancelInvitation($invitationId: ID!) {
        cancelInvitation(invitationId: $invitationId)
    }
`);

export const SEND_WORKER_INVITATION = gql(`
    mutation SendInvitation($phoneNumber: String!, $firstName: String, $lastName: String) {
        sendInvitation(phoneNumber: $phoneNumber, firstName: $firstName, lastName: $lastName) {
            __typename
            ... on SendInvitationSuccess {
                newInvitation
            }
            ... on SendInvitationError {
                message
                messageKey
            }
        }
    }
`);

export const SEND_CLIENT_INVITATION = gql(`
    mutation SendClientInvitation($phoneNumber: String!, $firstName: String, $lastName: String) {
        sendClientInvitation(phoneNumber: $phoneNumber, firstName: $firstName, lastName: $lastName) {
            __typename
            ... on SendInvitationSuccess {
                newInvitation
            }
            ... on SendInvitationError {
                message
                messageKey
            }
        }
    }
`);
